import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../../../common/SafeIcon';

const SCOPE_OPTIONS = [
  { value: 'medical', label: 'Medical Decisions', description: 'Authorize medical treatment, surgery, and healthcare decisions', icon: FiIcons.FiHeart },
  { value: 'school', label: 'School Enrollment', description: 'Enroll in school, sign school forms, and participate in educational decisions', icon: FiIcons.FiBook },
  { value: 'travel', label: 'Travel Consent', description: 'Authorize domestic and international travel on behalf of the child', icon: FiIcons.FiNavigation },
  { value: 'financial', label: 'Financial Decisions', description: 'Manage financial accounts and make purchases for the child\'s welfare', icon: FiIcons.FiDollarSign },
  { value: 'housing', label: 'Housing Decisions', description: 'Make decisions about the child\'s living arrangements and housing', icon: FiIcons.FiHome },
];

export const StepScopeAuthority = ({ formData, onChange, errors }) => {
  const selected = formData.scopeOfAuthority || [];

  const toggle = (value) => {
    const updated = selected.includes(value)
      ? selected.filter((v) => v !== value)
      : [...selected, value];
    onChange({ ...formData, scopeOfAuthority: updated });
  };

  return (
    <div className="space-y-5">
      <div>
        <h3 className="text-lg font-semibold text-brand-navy mb-1">Scope of Authority</h3>
        <p className="text-sm text-slate-500">Select all powers you are granting to the designated guardian.</p>
      </div>

      {errors.scopeOfAuthority && (
        <p className="text-sm text-red-600 bg-red-50 border border-red-200 rounded-md px-3 py-2 flex items-center gap-2">
          <SafeIcon icon={FiIcons.FiAlertCircle} /> {errors.scopeOfAuthority}
        </p>
      )}

      <div className="space-y-3">
        {SCOPE_OPTIONS.map((opt) => {
          const isSelected = selected.includes(opt.value);
          return (
            <button
              key={opt.value}
              type="button"
              onClick={() => toggle(opt.value)}
              className={`w-full flex items-center gap-4 p-4 rounded-lg border text-left transition-all ${
                isSelected
                  ? 'border-slate-900 bg-slate-900 text-white'
                  : 'border-slate-200 bg-white hover:border-slate-400 text-slate-700'
              }`}
            >
              <div className={`p-2 rounded-md flex-shrink-0 ${isSelected ? 'bg-slate-700' : 'bg-slate-100'}`}>
                <SafeIcon icon={opt.icon} className={isSelected ? 'text-white' : 'text-slate-600'} />
              </div>
              <div className="flex-1">
                <p className={`font-medium text-sm ${isSelected ? 'text-white' : 'text-slate-800'}`}>{opt.label}</p>
                <p className={`text-xs mt-0.5 ${isSelected ? 'text-slate-300' : 'text-slate-500'}`}>{opt.description}</p>
              </div>
              <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center flex-shrink-0 ${isSelected ? 'border-white bg-white' : 'border-slate-300'}`}>
                {isSelected && <SafeIcon icon={FiIcons.FiCheck} className="text-slate-900 text-xs" />}
              </div>
            </button>
          );
        })}
      </div>

      {selected.length > 0 && (
        <p className="text-xs text-slate-500 text-right">{selected.length} of {SCOPE_OPTIONS.length} authorities granted</p>
      )}
    </div>
  );
};